<app-loader *ngIf="isDisabled || isGrouping"></app-loader>
<div class="p-2">
    <div class="row gx-3 gy-2 mb-2" style="justify-content:right">
        <div class="col"></div>
        <div class="col-md-3" *ngIf="mfilter.filterType == 1">
            <ngb-datepicker #dp [(ngModel)]="mfilter.FromDate" class="month-year"
                (navigate)="mfilter.FromDate= $event.next;onNavigate($event)"></ngb-datepicker>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateRange" [(ngModel)]="mfilter.FromDate"
                    ngbDatepicker #FromDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2 || mfilter.filterType == 4">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateRange" [(ngModel)]="mfilter.ToDate"
                    ngbDatepicker #ToDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2">
            <select class="form-select" aria-label="filterType" placeholder="filterType" title="filterType"
                name="filterType" [(ngModel)]="mfilter.filterType" #filterType="ngModel" required>
                <option value='3'>Yesterday</option>
                <option value='0'>Today</option>
                <option value='1'>Monthly</option>
                <option value='4'>Date</option>
                <option value='2'>Date Range</option>
            </select>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="FetchData()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Fetch Data':'Loading...'}}</button>
        </div>
        <!-- <div class="col-auto">
            <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn btn-outline-primary" id="filterForm" [disabled]="isDisabled"
                    ngbDropdownToggle>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Filter':'Loading...'}}
                </button>
                <div ngbDropdownMenu aria-labelledby="filterForm" class="filtertoggle p-2">
                    <label>Group By</label>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="groupby.State"
                                    name="groupbyState" id="groupbyState">
                                <label class="form-check-label" for="groupbyState">State</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="groupby.Branch"
                                    name="groupbyBranch" id="groupbyBranch">
                                <label class="form-check-label" for="groupbyBranch">Branch</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="groupby.Client"
                                    name="groupbyClient" id="groupbyClient">
                                <label class="form-check-label" for="groupbyClient">Client</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="groupby.Site"
                                    name="groupbySite" id="groupbySite">
                                <label class="form-check-label" for="groupbySite">Site</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-auto"><button type="button" class="btn btn-primary"
                                (click)="FilterForm()">Apply</button></div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Dashboard - Front Office
    </div>
    <div class="card-body p-1">
        <div class="p-2">
            <div class="row gx-3 gy-2 mb-2">
                <div class="col-md-3">
                    <ng-select [items]="ShiftGroups" [multiple]="true" bindLabel="ShiftGroupName"
                        bindValue="ShiftGroupMasterID" placeholder="All Shiftgroup" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.ShiftGroupMasterID" [virtualScroll]="true"
                        (change)="DropdownChange('ShiftGroup')">

                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'ShiftGroup')" /> Check All
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ShiftGroupName">{{item.ShiftGroupName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ShiftGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Shifts" [multiple]="true" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="All Shift" [closeOnSelect]="false" [(ngModel)]="mfilter.ShiftMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Shift')">

                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Shift')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- <div class="row">
                                <div class="col"> -->
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ShiftTitle">{{item.ShiftTitle}}</span>
                            <!-- </div>
                                <div class="col-auto">
                                    {{GetCount('Shift',item.ShiftMasterID)}}
                                </div>
                            </div> -->
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ShiftTitle}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <!-- <div class="col-md-3">
                    <ng-select [items]="States" [multiple]="true" bindLabel="StateName" bindValue="StateMasterID"
                        placeholder="All State" [closeOnSelect]="false" [(ngModel)]="mfilter.StateMasterID"
                        (change)="DropdownChange('State')" [virtualScroll]="true">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.StateName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.StateName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div> -->
                <div class="col-md-3">
                    <ng-select [items]="Regions" [multiple]="true" bindLabel="RegionName" bindValue="RegionMasterID"
                        placeholder="All Region" [closeOnSelect]="false" [(ngModel)]="mfilter.RegionMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Region')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Region')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.RegionName">{{item.RegionName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.RegionName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="All Branch" [closeOnSelect]="false" [(ngModel)]="mfilter.BranchMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Branch')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- <div class="row">
                                <div class="col"> -->
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.BranchName">{{item.BranchName}}</span>
                            <!-- </div>
                                <div class="col-auto">
                                    {{GetCount('Branch',item.BranchMasterID)}}
                                </div>
                            </div> -->
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 gy-2 mb-2">

                <!-- <div class="col-md-3">
                    <ng-select [items]="Zones" [multiple]="true" bindLabel="ZoneName" bindValue="ZoneID"
                        placeholder="All Zone" [closeOnSelect]="false" [(ngModel)]="mfilter.ZoneID"
                        (change)="DropdownChange('Zone')" [virtualScroll]="true">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.ZoneName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ZoneName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div> -->
                <div class="col-md-3">
                    <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" placeholder="All Client" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.ClientGroupMasterID" [virtualScroll]="true"
                        (change)="DropdownChange('Client')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Client')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- <div class="row">
                                <div class="col"> -->
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ClientGroupName">{{item.ClientGroupName}}</span>
                            <!-- </div>
                                <div class="col-auto">
                                    {{GetCount('Client',item.ClientGroupMasterID)}}
                                </div>
                            </div> -->
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ClientGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="All Site" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Site')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- <div class="row">
                                <div class="col"> -->
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.SiteName">{{item.SiteName}}</span>
                            <!-- </div>
                                <div class="col-auto">
                                    {{GetCount('Site',item.SiteMasterID)}}
                                </div>
                            </div> -->
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="SiteOwners" [multiple]="true" bindLabel="SiteOwnerName" bindValue="SiteOwnerID"
                        placeholder="All Supervisor" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteOwnerID"
                        [virtualScroll]="true">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'SiteOwner')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- <div class="row">
                                <div class="col"> -->
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.SiteOwnerName">{{item.SiteOwnerName}}</span>
                            <!-- </div>
                                <div class="col-auto">
                                    {{GetCount('Supervisor',item.SiteOwnerID)}}
                                </div>
                            </div> -->
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteOwnerName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="IndustrySegments" [multiple]="true" bindLabel="IndustrySegmentName"
                        bindValue="IndustrySegmentId" placeholder="All Segment" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.IndustrySegmentId" [virtualScroll]="true">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'IndustrySegment')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.IndustrySegmentName">{{item.IndustrySegmentName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.IndustrySegmentName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 mb-2">
                <div class="col"></div>
                <div class="col-auto">
                    <button class="btn btn-primary" type="button" (click)="FilterForm()"
                        [disabled]="isDisabled || isApply"><i class="bi bi-funnel me-2" *ngIf="!isApply"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isApply"></span>
                        {{!isApply?'Apply':'Applying...'}}
                    </button>
                </div>
            </div>
            <!-- <div class="row gx-0 mb-2">
                <div class="col">
                    <div
                        style="background: linear-gradient(to top right, #3f51b5,#1E9BEB);height: 8rem;display: flex;justify-content: center;align-items: center;text-align: center;">
                        <div class="center">
                            <label style="color: #fff;font-size: 2rem;font-weight:200">100</label>
                            <br />
                            <label class="badge black px-3">Total</label>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        style="background: linear-gradient(to top right, #00d68f,#00d68f67);height: 8rem;display: flex;justify-content: center;align-items: center;text-align: center;">
                        <div class="center">
                            <label style="color: #fff;font-size: 2rem;font-weight:200">75</label>
                            <br />
                            <label class="badge black px-3">Present</label>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        style="background: linear-gradient(to top right, #00d68f,#00d68f67);height: 8rem;display: flex;justify-content: center;align-items: center;text-align: center;">
                        <div class="center">
                            <label style="color: #fff;font-size: 2rem;font-weight:200">75%</label>
                            <br />
                            <label class="badge black px-3">Present %</label>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        style="background: linear-gradient(to top right, #FF0000,#ff000063);height: 8rem;display: flex;justify-content: center;align-items: center;text-align: center;">
                        <div class="center">
                            <label style="color: #fff;font-size: 2rem;font-weight:200">25</label>
                            <br />
                            <label class="badge black px-3">Absent</label>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div
                        style="background: linear-gradient(to top right, #FF0000,#ff000063);height: 8rem;display: flex;justify-content: center;align-items: center;text-align: center;">
                        <div class="center">
                            <label style="color: #fff;font-size: 2rem;font-weight:200">25%</label>
                            <br />
                            <label class="badge black px-3">Absent%</label>
                        </div>
                    </div>
                </div>
                <div class="col bg-white">
                    <canvas baseChart style="width: 100%;" height="120" [type]="'doughnut'" [data]="TestChartData"
                        [legend]="false">
                    </canvas>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4 p-0">
                            <div class="row">

                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 30px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #0078D4;color: #fff;">
                                                <i class="bi bi-people fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #EBF3FE;color: #0078D4;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Total Billable</div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count"
                                                    style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                                    {{Card.Total}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12"
                                    *ngIf="this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 30px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #0078D4;color: #fff;">
                                                <i class="bi bi-person-raised-hand fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #EBF3FE;color: #0078D4;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Total Active</div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count"
                                                    style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                                    {{Card.TotalActive}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #00d68f;color: #fff;">
                                                <i class="bi bi-person-check fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #E6FFFA;color: #00d68f;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Present</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge success"
                                                                style="background-color: #00d68f;height: auto;font-size: large;">{{Card.PresentPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.Present}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #00A36C;color: #fff;">
                                                <i class="bi bi-person-check-fill fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #00a36d2e;color: #00A36C;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <!-- <div class="col" style="text-align: left;">Manual Attendance
                                                        </div> -->
                                                        <div class="col" style="text-align: left;">Digital Attendance
                                                        </div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge"
                                                                style="background-color: #00A36C;height: auto;font-size: large;">{{Card.OnlineAttendancePer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.OnlineAttendance}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #FF0000;color: #fff;">
                                                <i class="bi bi-person-x fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #FBF2EF;color: #FF0000;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Absent</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge danger"
                                                                style="background-color: #FF0000;height: auto;font-size: large;">{{Card.AbsentPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.Absent}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #6A0DAD;color: #fff;">
                                                <i class="bi bi-calendar-week fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #c999eb;color: #6A0DAD;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Weekoff</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge"
                                                                style="background-color: #6A0DAD;height: auto;font-size: large;">{{Card.WOPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.WO}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-4">
                    <div class="tile m-1">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #0078D4;color: #fff;">
                                <i class="bi bi-people fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #EBF3FE;color: #0078D4;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    Total
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                    {{Card.Total}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="tile m-1">
                        <div class="row" style="line-height: 34px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #00d68f;color: #fff;">
                                <i class="bi bi-person-check fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #E6FFFA;color: #00d68f;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    <div class="row">
                                        <div class="col-auto" style="font-size:large; font-weight: 400;"><span
                                                class="badge success"
                                                style="background-color: #00d68f;">{{Card.PresentPer}}%</span></div>
                                        <!-- <div class="col-auto">
                                            <canvas baseChart width="35" height="35" [type]="'doughnut'" [data]="CardChartData"
                                                [legend]="false"
                                                [options]="{responsive: true,rotation: -90,circumference: 180,}">
                                            </canvas>
                                        </div> -->
            <!-- <div class="col">Present</div>
                                    </div>
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.Present}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-4 p-0 m-0" style="background-image: url(../../../assets/5153829.jpg);background-size: cover;background-color: #fff;background-repeat: no-repeat;background-position: center"></div>
                            <div class="col-7 text-end gy-2 p-0 m-0">
                                <div class="m-1" style="font-size:small; font-weight: 400;">
                                    Present %
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.PresentPer}}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- <div class="col-4">
                    <div class="tile m-1">
                        <div class="row" style="line-height: 34px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #FF0000;color: #fff;">
                                <i class="bi bi-person-x fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #FBF2EF;color: #FF0000;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    <div class="row">
                                        <div class="col-auto" style="font-size:large; font-weight: 400;"><span
                                                class="badge danger"
                                                style="background-color: #FF0000;">{{Card.AbsentPer}}%</span></div>
                                        <div class="col">Absent</div>
                                    </div>
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.Absent}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-4 p-0 m-0" style="background-image: url(../../../assets/5153829.jpg);background-size: cover;background-color: #fff;background-repeat: no-repeat;background-position: center"></div>
                            <div class="col-7 text-end gy-2 p-0 m-0">
                                <div class="m-1" style="font-size:small; font-weight: 400;">
                                    Absent %
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.AbsentPer}}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- </div> -->
            <!-- <div class="row gx-3">
                <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-9">
                                <div class="count" style="color: var(--primary)">
                                    {{Card.Total}}
                                </div>
                                <div class="label">
                                    Total
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="icon">
                                    <i class="bi bi-people-fill" style="color: var(--primary)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-9">
                                <div class="count" style="color: var(--success)">
                                    {{Card.Present}}
                                </div>
                                <div class="label">
                                    Present
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="icon">
                                    <i class="bi bi-person-check-fill" style="color: var(--success)"></i>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
                <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-9">
                                <div class="count" style="color: var(--success)">
                                    {{Card.PresentPer.toFixed(2)}}%
                                </div>
                                <div class="label">
                                    Present %
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="icon">
                                    <i class="bi bi-person-check-fill" style="color: var(--success)"></i>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
                <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-9">
                                <div class="count" style="color: #FF0000">
                                    {{Card.Absent}}
                                </div>
                                <div class="label">
                                    Absent
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="icon">
                                    <i class="bi bi-person-x-fill" style="color: #FF0000"></i>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
                <div class="col">
                    <div class="tile">
                        <div class="row">
                            <div class="col-9">
                                <div class="count" style="color: #FF0000">
                                    {{Card.AbsentPer.toFixed(2)}}%
                                </div>
                                <div class="label">
                                    Absent %
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="icon">
                                    <i class="bi bi-person-x-fill" style="color: #FF0000"></i>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
            </div> -->
        </div>
        <div class="card border-radius-0 m-1 p-0" id="Attendance">
            <div class="card-header">
                <div class="row">
                    <div class="col">Attendance</div>
                    <div class="col-auto">
                        <div class="form-check form-switch"
                            (click)="Collapsed.AttendanceGraph = !Collapsed.AttendanceGraph">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.AttendanceGraph" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.AttendanceGraph,'toggle-off':!Collapsed.AttendanceGraph}"
                                for="flexSwitchCheckDefault">{{Collapsed.AttendanceGraph?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.AttendanceGraph">
                <div class="chart-scroll-container">
                    <div class="chart-container">
                        <canvas baseChart [type]="'bar'" [data]="AttendanceChartData"
                            [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {ticks: {font: {size: 10}}}}}"
                            [legend]="ChartLegend.Attendance">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border-radius-0 m-1 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col">Branch</div>
                    <div class="col-auto">
                        <div class="form-check form-switch"
                            (click)="Collapsed.BranchGraph = !Collapsed.BranchGraph;CardOpenClose('CardBranchGraph')">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.BranchGraph" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.BranchGraph,'toggle-off':!Collapsed.BranchGraph}"
                                for="flexSwitchCheckDefault">{{Collapsed.BranchGraph?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.BranchGraph">
                <div class="chart-scroll-container">
                    <div class="chart-container">
                        <canvas baseChart [type]="'bar'" [data]="BranchChartData"
                            [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {stacked: true,ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {stacked: true,ticks: {font: {size: 10}}}}}"
                            [legend]="ChartLegend.Branch">
                        </canvas>
                    </div>
                </div>

                <!-- <div style="display: block;">
                    <canvas baseChart style="width: 100%;" width="1000" height="500" [type]="'bar'"
                        [data]="BranchChartData" [legend]="ChartLegend.Branch" [options]="{interaction: {intersect: false},scales: {
                            x: {
                            stacked: true,
                            ticks: {
                                    maxRotation: 90,
                                    minRotation: 90,
                                    autoSkip: false,
                                }
                            },
                            y: {
                            stacked: true
                            }
                        }}">
                    </canvas>
                </div> -->
            </div>
        </div>
        <div>
            <div class="row">
                <!-- <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-primary"  [routerLink]="['/master/shift/add/',0]" [disabled]="isDisabled">
                        <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Add Shift':'Loading...'}}
                    </button>
                </div> -->
            </div>
            <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Analytics</div>
                        <div class="col-auto"><button type="button" class="btn btn-primary btn-sm"
                                [disabled]="isDisabled" (click)="ExcelDump(0)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel':'Loading...'}}</button>
                        </div>
                        <div class="col-auto">
                            <div ngbDropdown class="d-inline-block" #groupDrop="ngbDropdown">
                                <button type="button" class="btn btn-outline-primary btn-sm" id="dropdownForm1"
                                    ngbDropdownToggle [disabled]="isDisabled || isGrouping">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isGrouping"></span>Grouping
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownForm1" display="dynamic">
                                    <form class="px-4 py-3" (submit)="showGroup()">
                                        <label class="Label">
                                            <input type="checkbox" name="groupCheckall" (change)="CheckAllGroupBy()"
                                                [(ngModel)]="groupby.Checkall" ngbCheckbox />
                                            Select All
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupState" [(ngModel)]="groupby.State"
                                                ngbCheckbox />
                                            State
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupRegion" [(ngModel)]="groupby.Region"
                                                ngbCheckbox />
                                            Region
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupBranch" [(ngModel)]="groupby.Branch"
                                                ngbCheckbox /> Branch
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupClient" [(ngModel)]="groupby.Client"
                                                ngbCheckbox /> Client
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupSite" [(ngModel)]="groupby.Site"
                                                ngbCheckbox />
                                            Site
                                        </label><br />
                                        <!-- <label class="Label">
                                            <input type="checkbox" name="groupSupervisor" [(ngModel)]="groupby.Supervisor"
                                                ngbCheckbox />
                                            Supervisor
                                        </label><br /> -->

                                        <div class="dropdown-divider"></div>
                                        <button type="submit" (click)="groupDrop.close();"
                                            class="btn btn-outline-primary btn-sm">Apply</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.AttendanceAnalytics = !Collapsed.AttendanceAnalytics;CardOpenClose('CardAnalytics')">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [ngModel]="Collapsed.AttendanceAnalytics" (change)="$event.preventDefault();">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.AttendanceAnalytics,'toggle-off':!Collapsed.AttendanceAnalytics}"
                                    for="flexSwitchCheckDefault">{{Collapsed.AttendanceAnalytics?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                    [(ngbCollapse)]="!Collapsed.AttendanceAnalytics">
                    <table datatable [dtOptions]="dtOptions
                    " [dtTrigger]="dtTrigger" id="summarydata" class="customeDatatable table table-bordered"
                        name="summarydata">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th style="width: 200px;">SiteManpower</th>
                                <th style="width: 200px;">Present</th>
                                <th style="width: 200px;">Weekoff</th>
                                <th style="width: 200px;">Absent</th>
                                <th style="width: 200px;">Absent%</th>
                                <th [ngClass]="{'colHide': !groupby.State}" style="width: 500px;">State Name</th>
                                <th [ngClass]="{'colHide': !groupby.Region}" style="width: 500px;">Region Name</th>
                                <th [ngClass]="{'colHide': !groupby.Branch}">Branch Name</th>
                                <th [ngClass]="{'colHide': !groupby.Client}" style="width: 500px;">Client Name</th>
                                <th [ngClass]="{'colHide': !groupby.Site}" style="width: 500px;">Site Name</th>
                                <th [ngClass]="{'colHide': !groupby.Site || !this.common.CompanyParameterValue.IsDeviceAttendanceApplicable}" style="width: 500px;">DeviceInfo</th>
                                <th [ngClass]="{'colHide': !groupby.Site}" style="width: 200px;">Supervisor Name</th>
                                <!-- <th style="width: 200px;">Designation</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let TableData of filterData; let i = index">
                                <th scope="row" style="width: 5px;">{{i+1}}</th>
                                <td class="text-end">{{Sitemanpower(TableData)}}</td>
                                <!-- <td class="text-primary cursor-pointer text-end"
                                    (click)="EmpTableFilter('Present',groupby.Site?TableData[0]['SiteId']:groupby.Client?TableData[0]['ClientId']:groupby.Branch?TableData[0]['BranchId']:groupby.State?TableData[0]['StateId']:TableData[0]['SiteId'])">
                                    {{Present(TableData)}}</td> -->
                                <td class="text-end">{{PresentOnlineAttendance(TableData)}}</td>
                                <td class="text-end">{{Weekoff(TableData)}}</td>
                                <!-- <td class="text-primary cursor-pointer text-end"
                                    (click)="EmpTableFilter('Absent',groupby.Site?TableData[0]['SiteId']:groupby.Client?TableData[0]['ClientId']:groupby.Branch?TableData[0]['BranchId']:groupby.State?TableData[0]['StateId']:TableData[0]['SiteId'])">
                                    {{Absent(TableData)}}</td> -->
                                <td class="text-end">{{Absent(TableData)}}</td>
                                <td class="text-end">{{AbsentPer(TableData).toFixed(2)}}%</td>
                                <td [ngClass]="{'colHide': !groupby.State}" style="width: 500px;"
                                    class="text-primary cursor-pointer"
                                    (click)="EmpTableFilter('State',TableData[0]['StateId'])">
                                    {{groupby.State?TableData[0]['StateName']:''}}</td>
                                <td [ngClass]="{'colHide': !groupby.Region}" style="width: 500px;"
                                    class="text-primary cursor-pointer"
                                    (click)="EmpTableFilter('Region',TableData[0]['RegionMasterID'])">
                                    {{groupby.Region?TableData[0]['RegionName']:''}}</td>
                                <td [ngClass]="{'colHide': !groupby.Branch}" class="text-primary cursor-pointer"
                                    (click)="EmpTableFilter('Branch',TableData[0]['BranchId'])">
                                    {{groupby.Branch?TableData[0]['BranchName']:''}}
                                </td>
                                <td [ngClass]="{'colHide': !groupby.Client}" style="width: 500px;"
                                    class="text-primary cursor-pointer"
                                    (click)="EmpTableFilter('Client',TableData[0]['ClientId'])">
                                    <div style="width: 200px;">{{groupby.Client?TableData[0]['ClientName']:''}}</div>
                                </td>
                                <td [ngClass]="{'colHide': !groupby.Site}" style="width: 500px;"
                                    class="text-primary cursor-pointer"
                                    (click)="EmpTableFilter('Site',TableData[0]['SiteId'])">
                                    <div style="width: 300px;">{{groupby.Site?TableData[0]['SiteName']:''}}</div>
                                </td>
                                <td [ngClass]="{'colHide': !groupby.Site || !this.common.CompanyParameterValue.IsDeviceAttendanceApplicable}" style="width: 500px;"
                                    class="text-primary cursor-pointer">
                                    <div *ngIf="TableData[0]['DeviceInfo']" class="device-list" style="font-size: 12px;">
                                        <div *ngFor="let device of getDeviceList(TableData[0]['DeviceInfo']); let j = index"
                                            class="device-item" style="display: flex; align-items: center; margin-bottom: 3px;"
                                            (click)="GotoDevice(device.serial)">
                                            <span class="device-serial" style="flex: 1; margin: 0 8px;">
                                                {{device.serial}}
                                            </span>

                                            <span class="device-status"
                                                [ngClass]="{'status-active': device.status === '0', 'status-inactive': device.status === '1'}"
                                                style="width: 10px; height: 10px; border-radius: 50%; display: inline-block;">
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td [ngClass]="{'colHide': !groupby.Site}" style="width: 200px;">
                                    <div style="width: 200px;">{{groupby.Site?TableData[0]['SiteSupervisorName']:''}}
                                    </div>
                                </td>
                                <!-- <td style="width: 200px;">{{TableData[0]['DesignationName']}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Employee Details</div>
                        <div class="col-auto">
                            <button *ngIf="filterEmpData.length > 0" type="button" class="btn btn-primary btn-sm"
                                [disabled]="isDisabled" (click)="ExcelDump(1)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel Filter Data':'Loading...'}}</button>

                            <button *ngIf="this.mfilter.EmpDataLoad" type="button" class="btn btn-primary btn-sm mx-2"
                                [disabled]="isDisabled" (click)="ExcelDump(3)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel All Data':'Loading...'}}</button>

                            <button *ngIf="!this.mfilter.EmpDataLoad" type="button" class="btn btn-primary btn-sm"
                                [disabled]="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Fetching...</button>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.EmployeeDetails = !Collapsed.EmployeeDetails">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [ngModel]="Collapsed.EmployeeDetails" (change)="$event.preventDefault();">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.EmployeeDetails,'toggle-off':!Collapsed.EmployeeDetails}"
                                    for="flexSwitchCheckDefault">{{Collapsed.EmployeeDetails?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                    [(ngbCollapse)]="!Collapsed.EmployeeDetails">
                    <table datatable [dtOptions]="dtOptionsEmp" [dtTrigger]="dtTriggerEmp" id="empdatatable"
                        class="customeDatatable table table-bordered" name="empdatatable">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <!-- <th>EmpCode</th>
                                <th>Name</th>
                                <th>Designation</th> -->
                                <th>Details</th>
                                <!-- <th>Department Name</th> -->
                                <th>Shift Group</th>
                                <th>Shift Name</th>
                                <th>AttendanceDate</th>
                                <th>Attendance</th>
                                <th>InTime</th>
                                <th>OutTime</th>
                                <th>State Name</th>
                                <th>Branch Name</th>
                                <th style="width: 1000px;">Client Name</th>
                                <th style="width: 1000px;">Site Name</th>
                                <th style="width: 200px;">Supervisor Name</th>
                                <!-- <th style="width: 200px;">Designation</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let TableDataEmp of filterEmpData; let i = index">
                                <th scope="row" style="width: 5px;">{{i+1}}</th>
                                <!-- <td>{{TableDataEmp['EmpCode']}}</td>
                                <td>
                                    <div style="width: 200px;">{{TableDataEmp['EmployeeName']}}</div>
                                </td>
                                <td>
                                    <div style="width: 200px;">{{TableDataEmp['DesignationName']}}</div>
                                </td> -->
                                <td>
                                    <div class="row no-gutters cursor-pointer"
                                        style="align-items: center;width: 300px;">
                                        <div class="col-2">
                                            <img *ngIf="TableDataEmp['EmpPhoto'] != null && TableDataEmp['EmpPhoto'] != ''"
                                                (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableDataEmp['EmpPhoto']),Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo']} )"
                                                mat-card-image class="userImage"
                                                [src]="common.PhotoLink(TableDataEmp['EmpPhoto'])" />
                                            <div *ngIf="TableDataEmp['EmpPhoto'] == null || TableDataEmp['EmpPhoto'] == ''"
                                                (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableDataEmp['EmpPhoto']),Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo']} )"
                                                class="initial-image">
                                                <div class="image">
                                                    {{common.getInitial(TableDataEmp['EmployeeName'])}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" col-9 userdetail">
                                            <span class="text-label">{{TableDataEmp['EmployeeName']}}</span><br />
                                            <span class="text-label-light">#{{TableDataEmp['EmpCode']}}</span><br />
                                            <span class="text-label-light">{{TableDataEmp['DesignationName']}}</span>
                                        </div>
                                    </div>
                                </td>
                                <!-- <td>
                                    <div style="width: 100px;">{{TableDataEmp['DepartmentName']}}</div>
                                </td> -->
                                <td>
                                    <div style="width:100px">{{TableDataEmp['ShiftGroupName']}}</div>
                                </td>
                                <td>
                                    <div style="width:100px">{{TableDataEmp['ShiftTitle']}}</div>
                                </td>
                                <td>{{TableDataEmp['AttendanceDate'] | date: 'dd MMM, yyyy'}}</td>
                                <td>{{TableDataEmp['AttendanceRemark']}} <span
                                        *ngIf="TableDataEmp['IsOnlineAttendance'] >= 1"> (R) </span></td>
                                <td>{{TableDataEmp['InTime'] | date : 'H:mm:ss'}} <br />
                                    <img *ngIf="TableDataEmp['DailyAttendancePhotoIn'] != null && TableDataEmp['DailyAttendancePhotoIn'] != ''"
                                        (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'In Date', MTitle2:'In Time',MData1: TableDataEmp['InTime'], MData2:TableDataEmp['InTime'],Address : TableDataEmp['CheckInAddress'], IsAttendanceMatch : TableDataEmp['IsInAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['AttendanceMatchPercentage'], Latitude : TableDataEmp['Latitude'], Longitude : TableDataEmp['Longitude']})"
                                        mat-card-image class="userImage"
                                        [src]="common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true)" />
                                    <div *ngIf="TableDataEmp['DailyAttendancePhotoIn'] == null || TableDataEmp['DailyAttendancePhotoIn'] == ''"
                                        (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'In Date', MTitle2:'In Time',MData1: TableDataEmp['InTime'], MData2:TableDataEmp['InTime'],Address : TableDataEmp['CheckInAddress'], IsAttendanceMatch : TableDataEmp['IsInAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['AttendanceMatchPercentage'], Latitude : TableDataEmp['Latitude'], Longitude : TableDataEmp['Longitude']})"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableDataEmp['EmployeeName'])}}
                                        </div>
                                    </div>
                                </td>
                                <td>{{TableDataEmp['OutTime'] | date : 'H:mm:ss'}} <br />
                                    <img *ngIf="TableDataEmp['DailyAttendancePhotoOut'] != null && TableDataEmp['DailyAttendancePhotoOut'] != ''"
                                        (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'Out Date', MTitle2:'Out Time',MData1: TableDataEmp['OutTime'], MData2:TableDataEmp['OutTime'],Address : TableDataEmp['CheckOutAddress'], IsAttendanceMatch : TableDataEmp['IsOutAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['OutAttendanceMatchPercentage'], Latitude : TableDataEmp['LatitudeOut'], Longitude : TableDataEmp['LongitudeOut']})"
                                        mat-card-image class="userImage"
                                        [src]="common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true)" />
                                    <div *ngIf="TableDataEmp['DailyAttendancePhotoOut'] == null || TableDataEmp['DailyAttendancePhotoOut'] == ''"
                                        (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['EmployeeName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'Out Date', MTitle2:'Out Time',MData1: TableDataEmp['OutTime'], MData2:TableDataEmp['OutTime'],Address : TableDataEmp['CheckOutAddress'], IsAttendanceMatch : TableDataEmp['IsOutAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['OutAttendanceMatchPercentage'], Latitude : TableDataEmp['LatitudeOut'], Longitude : TableDataEmp['LongitudeOut']})"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableDataEmp['EmployeeName'])}}
                                        </div>
                                    </div>
                                </td>
                                <td>{{TableDataEmp['StateName']}}</td>
                                <td>{{TableDataEmp['BranchName']}}</td>
                                <td style="width: 300px;">
                                    <div style="width: 300px;">{{TableDataEmp['ClientName']}}</div>
                                </td>
                                <td style="width: 300px;">
                                    <div style="width: 300px;">{{TableDataEmp['SiteName']}}</div>
                                </td>
                                <td style="width: 200px;">
                                    <div style="width: 200px;">{{TableDataEmp['SiteSupervisorName']}}</div>
                                </td>
                                <!-- <td style="width: 200px;">{{TableData[0]['DesignationName']}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0" id="SummaryDetails">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Summary Details</div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary btn-sm" [disabled]="isDisabled"
                                (click)="ExcelDump(2)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel':'Loading...'}}</button>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.SummaryDetails = !Collapsed.SummaryDetails">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [ngModel]="Collapsed.SummaryDetails" (change)="$event.preventDefault();">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.SummaryDetails,'toggle-off':!Collapsed.SummaryDetails}"
                                    for="flexSwitchCheckDefault">{{Collapsed.SummaryDetails?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                    [(ngbCollapse)]="!Collapsed.SummaryDetails">
                    <table datatable id="summarydatatable" class="customeDatatable table table-bordered"
                        [dtOptions]="dtOptionsSummaryDetail" [dtTrigger]="dtTriggerSummaryDetail" width="100%"
                        name="summarydatatable">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th>Total Manpower</th>
                                <th>Total Punch</th>
                                <th>Total Pending</th>
                                <th
                                    [ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled}">
                                    Total Active</th>
                                <th>Branch Name</th>
                                <th>Site Count</th>
                                <th>Punch</th>
                                <th>Pending</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let Branch of branchSummary; let i = index">
                                <th scope="row" style="width: 5px;">{{i+1}}</th>
                                <td class="text-end">
                                    <div>{{Branch.TotalManpower}}</div>
                                </td>
                                <td class="text-end">
                                    <div>{{Branch.TotalPunch}}</div>
                                </td>
                                <td class="text-end">
                                    <div>{{Branch.TotalPending}}</div>
                                </td>
                                <td class="text-end"
                                    [ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled}">
                                    <div>{{Branch.TotalActiveEmployeeCount}}</div>
                                </td>

                                <td>
                                    <div>{{Branch.Branch}}</div>
                                </td>
                                <td class="text-end">
                                    <div>{{Branch.Site}}</div>
                                </td>
                                <td class="text-end">
                                    <div>{{Branch.Punch}}</div>
                                </td>
                                <td class="text-end">
                                    <div>{{Branch.Pending}}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>